import { Routes } from '@angular/router';
import { CircuitMapComponent } from './circuit-map.component';
import { Authority } from '@app/shared/utils/enums';

export const circuitMapRoutes: Routes = [
    {
        path: 'circuit-map',
        children: [
            {
                path: '',
                component: CircuitMapComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
            }
        ]
    }
]